'use client';

import {active_posts as posts} from 'data/posts';
import {active_news as news} from 'data/news';
import Link from 'next/link';
import {format, formatDistanceToNow} from 'date-fns';
import PostSummary from 'components/Blog/PostSummary';
import {usePathname} from 'next/navigation';
import OperationsHeroSvg from 'animation/svg-anim/OperationsHeroSvg';
import BookBtn from 'components/buttons/BookBtn/BookBtn';
import Tags from 'components/Blog/PostTags';

const has_tag = tag => tag === 'all' ? p => true : p => (p?.tags ?? []).indexOf(tag) !== -1;
const do_negate = status => !status ? fn => (...args) => fn(...args) : fn => (...args) => !fn(...args);

const Blog = props => {
  const {tag = 'all', negate = false} = props;
  const is_news_page = tag === 'news-only';
  
  let data_source;
  if (is_news_page) {
    // Combine active_news with blog posts that have 'news' tag
    const news_tagged_posts = posts.filter(p => (p?.tags ?? []).indexOf('news') !== -1);
    data_source = [...news, ...news_tagged_posts].sort((a, b) => b.published.localeCompare(a.published));
  } else {
    data_source = posts;
  }
  
  const filter = is_news_page ? () => true : do_negate(negate)(has_tag(tag));
  const filtered_posts = data_source.filter(filter);

  const [featured, ...other_posts] = filtered_posts;

  const path = usePathname();
  const [resource, instance] = path.split('/').filter(x => x !== '');  

  return (
    <div className='feed'>
      <div className='container'>
        <div>
            <h3 className='subtitle-overline'>Featured {is_news_page ? 'news' : (resource === 'blog' ? (featured.tags.indexOf('news') !== -1 ? `news` : `post`) : resource)}</h3>
          <h2 className='featured-title'>{featured.title}</h2>
          <p>{featured.summary}</p>
          <div className='read-more-btn'>
              <BookBtn text='Read more' url={is_news_page ? featured.url : (resource === 'feed' ? (featured.tags.indexOf('news') !== -1 ? `news/${featured.id}` : `${featured.id}`) : `${featured.id}/`)} />
          </div>
        </div>
        <div className="design">
          <OperationsHeroSvg />
        </div>
      </div>
      <div className='grid'>
        {
          other_posts?.map(p => {
            let href = is_news_page ? p.url : (resource === 'feed' ? (p.tags.indexOf('news') !== -1 ? `${p.id}` : `/blog/${p.id}`) : `/${resource}/${p.id}/`);
            if(!href){
              href = `/blog/${p.id}`;
            }
            const link_component = is_news_page ? (
              <a href={href} className='arrow-link' target='_blank' rel='noopener noreferrer'>{'Read more'}</a>
            ) : (
              <Link href={href} legacyBehavior>
                <a className='arrow-link'>{'Read more'}</a>
              </Link>
            );
            return (
              <section key={p.id}>
                <div className='inner-container'>
                  {/* <h5 className='subtitle'>{format(new Date(p.published), 'MMM d, y')}</h5> */}
                  {p.author && <p className='author'>{p.author}</p>}
                  <p className='title' onClick={() => {location.href=href}}>{p.title}</p>
                  <p className='summary' onClick={() => {location.href=href}}>{p?.summary}</p>
                  <div className='read-more'>
                    <div>
                      {link_component}
                    </div>
                  </div>
                </div>
              </section>
            );
          })
        }
      </div>
    </div>
  );
};

export default Blog;
